import { render, staticRenderFns } from "./channelTargetSet.vue?vue&type=template&id=5d158fb4&"
import script from "./channelTargetSet.vue?vue&type=script&lang=js&"
export * from "./channelTargetSet.vue?vue&type=script&lang=js&"
import style0 from "./channelTargetSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports